import _get from 'lodash/get';

export default function (key, replace = {}) {
    let trans = _get(window.app.translations, key);

    // console.log('key',key)
    // console.log('window.app.translations',window.app.translations)
    // console.log('trans',trans)

    if(!trans) {
        return key;
    }

    trans = typeof trans === 'string' ? trans : `${trans}`;

    Object.keys(replace).forEach(function (key){
        trans = trans.replace(new RegExp(`\{${key}\}`, 'g'), replace[key]);
    });

    return trans;
}
